export const unableToGetFacebookUserData = {
  code: 0,
  message: "Unable to get Facebook account data, either the process was interrupted or the user didn't grant rights."
};
